<template>
<div class='b-main-wrapper'
     :style='{
         height: height,
     }'>
    <transition name='fade'>
        <img v-show='imageStatus'
             style='height: 100%'
             class='icon'
             :src='src'
             @load='onLoaded'>&nbsp;
    </transition>
</div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FwImage extends Vue {
    @Prop({ type: String, default: null }) readonly src!: string;
    @Prop({ type: String, default: 'auto' }) readonly height!: string;
    loaded: boolean = false;
    get imageStatus() {
        return this.loaded;
    }
    onLoaded() {
        this.loaded = true;
    }
}
</script>

<style lang="sass">
    .b-main-wrapper
        background: transparent
    .fade-enter-active
        transition: opacity 0.3s ease-in-out
    .fade-enter-to
        opacity: 1
    .fade-enter
        opacity: 0

</style>
